import { AbstractControl, UntypedFormArray, UntypedFormControl, UntypedFormGroup, ValidationErrors } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { ToastService } from 'src/app/core';
import { CandidateProfile, CombainedProfile } from 'src/app/core/api.gen';
import { isNullOrUndefined } from '../../../app/core/utils';

export function EmailValidator(control: UntypedFormControl, field: FormlyFieldConfig): ValidationErrors {
  // return !control.value || /^\w+([\.\-\+]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(control.value) ? null : { 'email': true };
  return !control.value || /^\w+([\.]?[\-\_\w+])*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(control.value) ? null : { 'email': true };
}

export function blankSpaceValidator(control: UntypedFormControl, field: FormlyFieldConfig): ValidationErrors {
  const exp: RegExp = /\S/;
  // const exp1: RegExp = /^\S+.*\S+$/;
  return exp.test(control.value) ? null : { 'blankSpace': true };
}

export function EmailValidatorMessage(err, field: FormlyFieldConfig) {
  return `Please enter a valid email address`;
}
export function IntegerValidator(control: UntypedFormControl, field: FormlyFieldConfig): ValidationErrors {
  return !control.value || /^[0-9]*$/.test(control.value) ? null : { 'integer': true };
}
export function IntegerValidatorMessage(err, field: FormlyFieldConfig) {
  return `Please enter a valid number`;
}

export function IntegerwithNAValidator(control: UntypedFormControl, field: FormlyFieldConfig): ValidationErrors {
  return !control.value
    || control.value == "NA"
    || control.value == "Not Applicable"
    || /^[0-9]*$/.test(control.value) ? null : { 'integerwithNA': true };
}
export function IntegerwithNAValidatorMessage(err, field: FormlyFieldConfig) {
  return `Please enter a valid number`;
}
export function customError(err) {
  return err;
}

export function invalidDataCheck(controlArray: UntypedFormArray): boolean {
  const invalid = [];
  controlArray.controls
    .forEach((c: UntypedFormGroup) => {
      const formControls = c.controls;
      // tslint:disable-next-line: forin
      for (const name in formControls) {
        const con = formControls[name];

        if (!isNullOrUndefined(con.errors) && !con.errors.required) {
          con.markAsTouched();
          invalid.push(con);
        } else {
          con.markAsUntouched();
        }

        if (con instanceof UntypedFormGroup) {
          for (const name in con.controls) {
            const control = con.controls[name];
            if (!isNullOrUndefined(control.errors) && !control.errors.required) {
              control.markAsTouched();
              invalid.push(control);
            } else {
              con.markAsUntouched();
            }
          }
        }
      }
    });
  return invalid.length > 0;
}
export function invalidCompletedDataCheck(controlArray: UntypedFormArray): { invalid: UntypedFormControl[], ignored: string[] } {
  const invalid = [];
  const fieldsToIgnore = [
      { name: 'passportExpiryDate', label: 'Passport Expiry Date' },
      { name: 'passportExpiryDate', label: 'New passport expiry date' },
      { name: 'dateOfTravel', label: 'Date of travel' },
      { name: 'tentativeStartDate', label: 'Start date' },
      { name: 'startDate', label: 'Start date' },
      { name: 'visaIssuanceDate', label: 'Date of issuance' },
      { name: 'rpExpiryDate', label: 'Residency Permit (RP) expiry date' },
      { name: 'visaExpiryDate', label: 'Visa Expiry Date' },
      { name: 'gracePeriodExpiryDate', label: 'Grace period expiry date' },
      { name: 'currentKSABusinessVisaExpiryDate', label: 'Expiry date of Current KSA' },
      { name: 'dateOfExit', label: 'Exit date' },
      { name: 'departureDate', label: 'Departure date' },
      { name: 'iqamaExpiryDateRenewed', label: 'Iqama expiry date (renewed)' },
      { name: 'iqamaExpiryDate', label: 'Iqama expiry date' },
      // Add more fields
  ];
  const fieldsIgnored = [];

  controlArray.controls.forEach((c: UntypedFormGroup) => {
    const formControls = c.controls;
    const validControls = Object.keys(formControls).filter(controlName => formControls[controlName].status !== 'DISABLED');
    console.log("formcontrol", formControls);

    for (const name of validControls) { 
        const con = formControls[name]; 
        const ignoredField = fieldsToIgnore.find(field => field.name === name);

        if (ignoredField) {
            fieldsIgnored.push(ignoredField.label + ' : ' + ( isNullOrUndefined(con.value)? 'No date added' : formatDate(con.value)));
            continue; // Skip validation for this field
        }

        if (con.errors) {
            con.markAsTouched();
            invalid.push(con); // Add to invalid array
        } else {
            con.markAsUntouched(); 
        }

        if (con instanceof UntypedFormGroup) {
            for (const nestedName in con.controls) {
                const control = con.controls[nestedName];

                const ignoredNestedField = fieldsToIgnore.find(field => field.name === nestedName);
                if (ignoredNestedField) {
                    fieldsIgnored.push(ignoredNestedField.label);
                    continue; // Skip validation for this nested field
                }

                if (control.errors) {
                    control.markAsTouched(); 
                    invalid.push(control); 
                } else {
                    control.markAsUntouched();
                }
            }
        }
    }
  });
  return { invalid, ignored: fieldsIgnored }; // Return both invalid controls and ignored fields
}

export function formatDate(date) {
  if (!date) return null;
   const day = date.getDate();
  const month = date.toLocaleString('default', { month: 'short' });
  const year = date.getFullYear();
  // Format: eg: "20-Aug-2030"
  const formattedDate = `${day}-${month}-${year}`;
  return formattedDate;
}

export function findInvalidControlTab(controlArray: UntypedFormArray): number {
  let invTab = null;
  let stopLoop = false;
  controlArray.controls.forEach((c: UntypedFormGroup, index) => {
    if (!stopLoop) {
      const formControls = c.controls;
      // tslint:disable-next-line: forin
      for (const name in formControls) {
        const con = formControls[name];
        if (!isNullOrUndefined(con.errors) && !con.errors.required) {
          invTab = index;
          stopLoop = true;
          return invTab;
        }
      }
    }
  });
  return invTab;
}

export function formControlInvalid(fg: AbstractControl, key: string) {
  const control = fg.get(key);
  if (control && control.invalid) {
    return true;
  }
  return false;
}

export function validContDuration(model: CandidateProfile, toast: ToastService) {

  const fixedTermIds = [1056, 714, 1058, 1059, 720, 1063, 1064, 1065, 1061, 4839];
  const unlimitedTermIds = [1057, 716, 721, 1060, 4840, 4834];
  const cd = model.contractDuration;

  if (fixedTermIds.includes(model.contractType.id)
    && !(cd > 0)) {
    toast.warning("Contract duration should be greater than Zero");
    return false;
  }

  if ((unlimitedTermIds.includes(model.contractType.id)
    && cd != 0)
    || (!isNullOrUndefined(cd) && cd.toString().length === 0)) {
    toast.warning("Contract duration should be Zero");
    return false;
  }
  return true;
}

export function isInternalTransfer(combProf: CombainedProfile, toast): boolean {
  const tTypeNA = !isNullOrUndefined(combProf.pbProfile.transferTypeID) && combProf.pbProfile.transferTypeID !== 975;
  const tSceneNA = !isNullOrUndefined(combProf.pbProfile.transferScenarioID) && combProf.pbProfile.transferScenarioID !== 983;

  if ((combProf.candidateProfile.employeeCategory.id === 717
    || combProf.candidateProfile.employeeCategory.id === 5972)
    && (!tTypeNA || !tSceneNA)) {
    toast.warning("Transfer Type should not be selected as Not Applicable when Employee category is Internal Transfer");
    return true;
  }

  if (combProf.candidateProfile.employeeCategory.id !== 717
    && combProf.candidateProfile.employeeCategory.id !== 5972
    && (tTypeNA || tSceneNA)) {
    toast.warning("Please select not applicable for both Transfer type and Transfer scenario");
    return true;
  }

  return false;
}
